<template>
  <div class="group-manage auto-process conmon-top">
    <el-container>
      <!--左侧分组-->
      <el-aside class="left-aside-type" width="220px">
        <div class="group-search">
          <el-input
            placeholder="请输入搜索内容"
            v-model.trim="groupName"
            @keyup.enter.native="searchGroupType">
            <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer" @click="searchGroupType"></i>
          </el-input>
        </div>

        <el-menu
          default-active="0"
          class="el-menu-vertical-demo"
          style="max-height: 910px;width:100%; border-right: none; overflow-y: auto;overflow-x:hidden;margin-bottom: 0;padding-bottom: 0"
          @open="handleOpen"
          @close="handleClose"
          text-color="#333"
          active-text-color="#333">
          <el-menu-item :class="item.choosen ? 'getIt' : ''" :index="index + ''" v-for="(item, index) in groups" :key="index" @click="chooseGroupType(index, item)">
            <div class="menu-btn" v-if="item.name !== '全部'">
              <i @click="editAutomationGroupDialog = true" v-if="butsObj.edit_group" class="el-icon-edit" style="margin-right: 0px;margin-top: -3px;"></i>
              <i @click="deleteGroupTypeItem(item)" v-if="butsObj.del_group" class="el-icon-close" style="margin-right: 5px;margin-top: -3px;"></i>
            </div>
            <span class="menu-title" :title="item.name">{{ item.name }}</span>
          </el-menu-item>
          <div class="add-group-btn" v-if="butsObj.add_group" @click="openAdd">
            <i class="el-icon-circle-plus-outline" title="添加分组"></i>
          </div>
        </el-menu>

      </el-aside>
      <!--右侧列表-->
      <div class="zy-wrap">
        <div class="base-input ovf-hd">
          <el-row class="search-title">
            <el-col :span="24" class="text-align-left">
              <i class="el-icon-search" style="font-weight: bold;"></i>
              <span class="order-list-search-span">筛选查询</span>
              <div :span="4" class="text-align-right" style="float: right;">
                <el-button class="search-open-close" type="text" @click="hide=!hide">{{ hide? '收起查询':'展开查询' }}</el-button>
                <i v-if="hide === true" @click="hide=!hide" class="el-icon-arrow-up search-open-close-i"></i>
                <i v-if="hide === false" @click="hide=!hide" class="el-icon-arrow-down search-open-close-i"></i>
                <el-button class="search-btn-new" type="primary" size="small" @click="searchLoad">查询</el-button>
              </div>
            </el-col>
          </el-row>
          <el-row class="search-content common-search-formtype" v-show="hide">
            <el-col :span="24" class="text-align-left">
              <span style="margin-left: 26px">输入搜索：</span>
              <el-input placeholder="请输入名称" @keyup.enter.native="searchLoad" clearable v-model.trim="searchNameTmp"></el-input>
            </el-col>
          </el-row>
        </div>
        <el-row class="search-title common-table-top common-search-formtype" style="padding-right:0;">
          <el-col :span="4" class="table-title">
            <i class="el-icon-document" style="font-weight: bold"></i>
            <span>自动流程</span>
          </el-col>
          <el-col :span="20" class="text-align-right safari-input-style">
            <el-button v-if="butsObj.add" type="primary" class="add-btn" @click="createActoProcress"
                       style="margin-left: 0;margin-right: 32px">创建自动流程</el-button>
            <span style="margin-left: 20px">移到分组：</span>
            <el-select style="margin-right:25px" v-model="group_id" @change="confirmChooseGroupType" :disabled="checkAll" placeholder="请选择目标分组">
              <el-option
                v-for="item in queryGroups"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <!--短信模板列表-->
        <el-table key="tableData" class="table table-checkbox-style" id="tableData" ref="multipleTable" :data="tableData" @selection-change="handleSelectionChange" v-loading="loading">
<!--          暂无数据-->
          <template slot="empty">
            <div class="newTableEmpty">暂无数据，去<span @click="createActoProcress">新建</span></div>
          </template>
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column prop="name" label="名称">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p>{{ scope.row.name }}</p>
                <div @click="look(scope.row)" slot="reference" class="name-wrapper op-link">
                  {{ scope.row.name }}
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="into_num" label="累计进入"></el-table-column>
          <el-table-column prop="update_time" label="最后更新">
            <template slot-scope="scope">
              {{ scope.row.update_time | formatDate }}
            </template>
          </el-table-column>
          <el-table-column prop="send_num" label="状态">
             <template slot-scope="scope">
              <div v-if="scope.row.status === 1"><span class="pointGray"></span>草稿</div>
              <div v-if="scope.row.status === 2"><span class="pointGreen"></span>进行中</div>
              <div v-if="scope.row.status === 3"><span class="pointRed"></span>已停止</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="190" style="display: flex;justify-content: center">
            <template slot-scope="scope">
              <div class="op-link" v-if="butsObj.details" @click="look(scope.row)">
                查看
              </div>
              <div class="op-link editColor" @click="openEditMessageDialog(scope.row)" v-if="scope.row.status !== 2&&butsObj.edit">
                编辑
              </div>
              <div v-if="scope.row.status !== 2&&butsObj.del" class="op-link deleteColor" @click="deleteAutomationAction(scope.row)">
                删除
              </div>
              <div v-if="scope.row.status === 3&&butsObj.start_or_stop" class="op-link" @click="doThis(scope.row.id)">
                启动
              </div>
              <div v-if="scope.row.status === 2&&butsObj.start_or_stop" class="op-link" @click="stopThis(scope.row.id)">
                停止
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="table-foot">
          <el-pagination
            class="table-foot-pagination"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="limit"
            :current-page="page"
            layout="total, prev, pager, next, jumper"
            :total="totalCount">
          </el-pagination>
        </div>
      </div>
    </el-container>

    <el-dialog class="cellDialog base-dialog" title="添加分组" :visible.sync="addAutomationGroupDialog" width="520px">
      <el-form :model="addGroupForm" :rules="rulesAdd" ref="addGroupForm">
        <el-form-item label="分组名称:" prop="automationGroupName" label-width="80px">
          <el-input v-model="addGroupForm.automationGroupName" placeholder="请输入分组名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="dialog-cancel-btn" @click="addAutomationGroupDialog = false">取 消</el-button>
        <el-button type="primary" style="margin-right: 32px" @click="addGroupTypeItem" class="dialog-confirm-btn">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog class="cellDialog base-dialog" title="修改分组" :visible.sync="editAutomationGroupDialog" width="520px">
      <el-form :model="addGroupForm" :rules="rulesAdd" ref="addGroupForm">
        <el-form-item label="分组名称:" prop="automationGroupName" label-width="80px">
          <el-input placeholder="请输入分组名称" v-model="addGroupForm.automationGroupName"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="dialog-cancel-btn" @click="editAutomationGroupDialog = false">取 消</el-button>
        <el-button type="primary" style="margin-right: 32px" @click="editGroupTypeItem" class="dialog-confirm-btn">确 定</el-button>
      </div>
    </el-dialog>

    <!--自动流程-->
    <el-dialog class="cellDialog auto-process-dialog" title="自动流程开始条件" :visible.sync="createdAutoProcressDialog" width="900px">
      <div style="display: flex; justify-content: space-between; flex-direction: row;">
        <div class="procress-left">
          <div class="auto-procress-condition">
            <ul>
              <li @click="procressSelectAction(index)" v-bind:class="{ active: item.selected }" :key="index" v-for="(item, index) in procressLeftData">
                <!-- <div style="width: 40px; height: 90px; float: left; "></div> -->
                <div class="procress-left-select">
                  <p>{{ item.title }}</p>
                  <!-- <p>{{ item.subTitle }}</p> -->
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="procress-right">
          <el-form :model="procressForm" ref="procressForm" :rules="procressFormRules">
            <!--实时-->
            <el-form-item v-if="selectIndex === 0" prop="query_id" label="选择群组" style="margin-bottom: 10px;">
              <el-select v-model="procressForm.query_id" filterable placeholder="请选择群组" style="width: 340px;" @change="selectGroupAction">
                <el-option
                  v-for="item in selectGroupOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id" style="width: 340px;">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="selectIndex === 0" prop="procressName" label="流程名称" style="margin-bottom: 10px;">
              <el-input  v-model="procressForm.procressName" placeholder="请输入流程名称" style="width: 340px;"></el-input>
            </el-form-item>
            <!-- 实时营销 -->
            <div v-if="selectIndex === 0">
              <el-form-item prop="selectRadio" label="设定触发条件">
                <el-radio-group v-model="selectRadio" @change="selectRadioChange">
                  <el-radio :label="0">事情发生</el-radio>
                  <el-radio :label="1">活跃度变化</el-radio>
                  <el-radio :label="2">属性变化</el-radio>
                </el-radio-group>
                <!-- 事情发生 -->
                <div v-if="selectRadio === 0">
                  <el-row>
                    <el-col style="width: 250px; margin-left: 114px;">
                      <el-checkbox v-model="checked" style="float: left;">允许同一用户重复进入</el-checkbox>
                      <el-cascader
                        v-model="selectedOptions"
                        :options="activityOptions"
                        @change="activitySelectChange"
                        style="margin-bottom: 10px; width: 340px; margin-left: 0px;">
                      </el-cascader>
                      <el-select v-model="subSelectedEvent" filterable v-show="selectShow" style="width: 340px;">
                        <el-option
                          v-for="i in changeOptions"
                          :key="i.value"
                          :label="i.label"
                          :value="i.value">
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                </div>
                <!-- 客户活跃度 -->
                <div v-if="selectRadio === 1">
                  <el-row>
                    <el-col style="width: 250px; margin-left: 114px;">
                      <!--<el-select v-model="selectActivityChange" placeholder="请选择活跃度类型" style="width: 340px; margin-bottom: 10px;">-->
                      <!--<el-option-->
                      <!--v-for="item in activityChangeOptions"-->
                      <!--:key="item.value"-->
                      <!--:label="item.label"-->
                      <!--:value="item.value">-->
                      <!--</el-option>-->
                      <!--</el-select>-->
                      <el-select v-model="selectUpAndDown" style="width: 340px; margin-bottom: 10px;">
                        <el-option
                          v-for="item in selectUpAndDownOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                      <el-input-number class="auto-process-act-change" controls-position="right" :min="-1000000000" :max="1000000000000" v-model="activityNum" style="margin-bottom: 10px; width: 340px;"  placeholder="请输入活跃度"></el-input-number>
                    </el-col>
                  </el-row>
                </div>
                <!-- 属性变化 -->
                <div v-if="selectRadio === 2">
                  <el-row>
                    <el-col style="width: 250px; margin-left: 114px;">
                      <el-checkbox v-model="attributeSelect" style="float: left;">允许同一用户重复进入</el-checkbox>
                      <el-cascader
                        :options="attributeOptions"
                        v-model="attrSelectedOptions"
                        @change="selectAttributeChange"
                        :show-all-levels="false" style="margin-bottom: 10px; width: 340px;">
                      </el-cascader>
                      <el-select v-model="relationSelect" style="width: 340px; margin-bottom: 10px;">
                        <el-option
                          v-for="item in relationOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                      <div v-if="controlType === 'select'">
                        <el-select v-model="selectAttribute" style="width: 340px; margin-bottom: 10px;">
                          <el-option
                            v-for="item in selectOptions"
                            :key="item"
                            :label="item"
                            :value="item">
                          </el-option>
                        </el-select>
                      </div>
                      <div v-if="controlType === 'radio'">
                        <el-select v-model="selectAttribute" style="width: 340px; margin-bottom: 10px;">
                          <el-option
                            v-for="item in selectOptions"
                            :key="item"
                            :label="item"
                            :value="item">
                          </el-option>
                        </el-select>
                      </div>
                      <el-input v-model="selectAttribute" style="margin-bottom: 10px; width: 340px;" v-if="controlType === 'input'"></el-input>
                      <el-cascader
                        v-if="controlType === 'addressPicker'"
                        style="width: 340px;"
                        size="large"
                        :options="addressOptions"
                        v-model="selectAttribute"
                        @change="update">
                      </el-cascader>
                      <el-date-picker
                        v-if="controlType === 'datePicker'"
                        v-model="selectAttribute"
                        type="date"
                        placeholder="选择日期"
                        style="width: 340px;">
                      </el-date-picker>
                      <el-date-picker
                        v-if="controlType === 'dateTimePicker'"
                        v-model="selectAttribute"
                        type="datetime"
                        class="dateTimePicker"
                        @change="update"
                        placeholder="选择时间和日期">
                      </el-date-picker>
                    </el-col>
                  </el-row>
                </div>
              </el-form-item>
            </div>
          </el-form>
          <el-form :model="oneForm" ref="oneForm" :rules="oneFormRules">
            <!--单次-->
            <el-form-item v-if="selectIndex === 1" prop="query_id" label="选择群组" style="margin-bottom: 10px;">
              <el-select v-model="oneForm.query_id" filterable placeholder="请选择群组" style="width: 340px;" @change="selectGroupAction">
                <el-option
                  v-for="item in selectGroupOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="selectIndex === 1" prop="procressName" label="流程名称" style="margin-bottom: 10px;">
              <el-input  v-model="oneForm.procressName" placeholder="请输入流程名称" style="width: 340px;"></el-input>
            </el-form-item>
            <!-- 单次营销 -->
            <div v-if="selectIndex === 1">
              <el-form-item label="">
              </el-form-item>
            </div>
          </el-form>
          <el-form :model="loopForm" ref="loopForm" :rules="loopFormRules">
            <!--周期性-->
            <el-form-item v-if="selectIndex === 2" prop="query_id" label="选择群组" style="margin-bottom: 10px;">
              <el-select v-model="loopForm.query_id" filterable placeholder="请选择群组" style="width: 340px;" @change="selectGroupAction">
                <el-option
                  v-for="item in selectGroupOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="selectIndex === 2" prop="procressName" label="流程名称" style="margin-bottom: 10px;">
              <el-input  v-model="loopForm.procressName" placeholder="请输入流程名称" style="width: 340px;"></el-input>
            </el-form-item>
            <div v-if="selectIndex === 2">
              <el-form-item label="时间设置" style="margin-bottom: 5px;">
                <el-radio-group v-model="dateRadio" @change="dateChange">
                  <el-radio :label="1">按天</el-radio>
                  <el-radio :label="2">按周</el-radio>
                  <el-radio :label="3">按月</el-radio>
                  <el-radio :label="4">按年</el-radio>
                </el-radio-group>
              </el-form-item>
              <div class="auto-process-line"></div>
              <date-template @change="getValue" :dateType="dayRadio" style="margin-left: 30px;" ></date-template>
              <el-form-item prop="realTime" label="具体时间" style="margin-top: 20px;margin-bottom: 0">
                <el-time-picker
                  style="width: 340px"
                  arrow-control
                  v-model="realTime"
                  placeholder="请选择时间">
                </el-time-picker>
              </el-form-item>
              <el-form-item prop="startEnd" class="start-end-time" label="起止时间" style="margin-top: 5px;">
                <el-date-picker
                  v-model="startEnd"
                  type="datetimerange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00']"
                  style="width: 340px!important; margin-top: 10px;">
                </el-date-picker>
              </el-form-item>
            </div>
          </el-form>
          <!-- 周期性营销 -->
          <div v-if="selectIndex === 3">
            <el-form-item label="选择属性">
              <el-select v-model="formInline" placeholder="--不限--" style="width: 340px;">
                <el-option label="区域一" value="shanghai"></el-option>
                <el-option label="区域二" value="beijing"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="时间设定" style="text-align: left;">
              <el-radio-group v-model="timeRadio" style="width: 203px; margin-left: 40px;">
                <el-radio :label="1" style="width: 30px;">当天</el-radio>
                <el-radio :label="2" style="width: 50px;">前一天</el-radio>
                <el-radio :label="3" style="width: 50px;">自定义</el-radio>
              </el-radio-group>
              <el-select v-model="value" placeholder="请选择" class="diy-time" style="width: 60px;">
                <el-option
                  v-for="item in dayOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-input-number v-model="num8" controls-position="right" @change="handleChange" :min="1" :max="10" style="width: 80px;" class="day-count-input"></el-input-number>
              <div class="time-tips">自动流程会在设定时间的上午8点触发</div>
            </el-form-item>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn"  style="margin-left: 20px" @click="createdAutoProcressDialog = false">取 消</el-button>
        <el-button type="primary" style="margin-right: 42px" @click="confirmAdd" class="dialog-confirm-btn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { regionDataPlus, CodeToText, TextToCode } from 'element-china-area-data'
import { getGroupList, getBigWheelList, changeFlowChartStatus, getFlowChartGroup, getAutomationList, deleteAutomation, deleteAutomationGroupById, addAutomationGroup, editAutomationGroupById, moveAutomationGroupId, createAutomation, getEventList, getWechatPublicListForNode, getWePagesListForNode, getMessageGroupList, getMessageList, getCustomerStage, getSourceData, getCustomerAttributeList } from '@/api/customer.js'
import { butonsList, getMenId } from '@/api/analyse.js'
import DateTemplate from '../common/date-template.vue'
import { mapMutations, mapGetters } from 'vuex'
import TemplateMessage from '../weixin-manage/template-message';
export default {
  name: 'autoProcress',
  data () {
    var validatePhone = (rule, value, callback) => {
      if (value) {
        return callback(new Error(''))
      }
    }
    return {
      loopFormRules: {
        query_id: [
          { required: true, message: '群组不能为空', trigger: 'change' }
        ],
        procressName: [
          { required: true, message: '流程名称不能为空', trigger: '' }
        ],
        realTime: [
          { required: true, validator: validatePhone, trigger: 'change' }
        ],
        startEnd: [
          { required: true, validator: validatePhone, trigger: 'change' }
        ]
      },
      oneFormRules: {
        query_id: [
          { required: true, message: '群组不能为空', trigger: 'change' }
        ],
        procressName: [
          { required: true, message: '流程名称不能为空', trigger: '' }
        ]
      },
      procressFormRules: {
        query_id: [
          { required: true, message: '群组不能为空', trigger: 'change' }
        ],
        procressName: [
          { required: true, message: '流程名称不能为空', trigger: '' }
        ],
        selectRadio: [
          { required: true, validator: validatePhone, trigger: 'change' }
        ]
      },
      rulesAdd: {
        automationGroupName: [
          { required: true, message: '请输入分组名称', trigger: 'blur' }
        ]
      },
      hide: true,
      loading: true,
      realTime: '',
      timeValue: {},
      search: {
        status: 2
      },
      activityNum: '',
      attrSelectedOptions: [],
      procressForm: {
        procressName: '',
        query_id: '',
        type: 0
      },
      oneForm: {
        procressName: '',
        query_id: '',
        type: 0
      },
      loopForm: {
        procressName: '',
        query_id: '',
        type: 0
      },
      startEnd: '',
      item: [],
      selectOptions: [],
      // 地区选择options: regionData,
      addressOptions: regionDataPlus,
      // 客户属性时间选择
      dateValue: '',
      selectAttribute: '',
      controlType: '',
      // 属性变化
      attributeSelect: false,
      attributeOptions: [],
      // 客户属性关系
      relationSelect: '',
      relationOptions: [
        {
          id: 1,
          value: '=',
          label: '等于'
        },
        {
          id: 2,
          value: '!=',
          label: '不等于'
        },
        {
          id: 3,
          value: 'contain',
          label: '包含'
        },
        {
          id: 4,
          value: 'not contain',
          label: '不包含'
        },
        {
          id: 5,
          value: 'empty',
          label: '为空'
        },
        {
          id: 6,
          value: 'not empty',
          label: '不为空'
        }
      ],
      selectUpAndDown: '',
      selectUpAndDownOptions: [
        {
          value: '=',
          label: '等于'
        }, {
          value: '>',
          label: '大于'
        }, {
          value: '<',
          label: '小于'
        }
      ],
      // 客户活跃度
      selectActivityChange: '',
      activityChangeOptions: [
        {
          value: 1,
          label: '客户活跃度'
        },
        {
          value: 2,
          label: '客户7天活跃度'
        },
        {
          value: 3,
          label: '客户30天活跃度'
        }
      ],
      selectShow: true,
      changeOptions: [],
      selectGroupOptions: [],
      procressName: '新建自动工作流',
      selectedOptions: [],
      activityOptions: [],
      limitTime: '',
      pageLink: '',
      searchNameTmp: '',
      searchName: '',
      addGroupForm: {
        automationGroupName: ''
      },
      addAutomationGroupDialog: false,
      editAutomationGroupDialog: false,
      num8: 1,
      dateRadio: 1,
      dayOptions: [
        {
          label: '前',
          value: 1
        },
        {
          label: '后',
          value: 2
        }
      ],
      value: '',
      timeRadio: 0,
      selectGroup: '',
      options: [],
      dayRadio: 1,
      checked: false,
      checked1: '',
      formInline: '',
      selectRadio: 0,
      selectIndex: 0,
      procressLeftData: [
        {
          title: '实时营销',
          subTitle: '在客户产生了某个事件动作或客户属性发生变化时，即时对其进行个性化触达。',
          selected: true
        },
        {
          title: '单次营销',
          subTitle: '对指定客群进行一次营销触达，执行一次即结束。',
          selected: false
        },
        {
          title: '周期性营销',
          subTitle: '以某个时间周期为条件，重复循环执行的营销策略。',
          selected: false
        }
      ],
      createdAutoProcressDialog: false,
      active: true,
      group_id: '',
      selectGroupId: '',
      queryGroups: [],
      tableData: [],
      totalData: [],
      customerData: [],
      limit: 10,
      totalCount: 0,
      value4: '',
      signs: [],
      messageTypes: [
        {
          name: '通知类型',
          id: 0
        },
        {
          name: '营销类型',
          id: 1
        }
      ],
      addForm: {
        name: ''
      },
      editForm: {
        name: ''
      },
      targetGroups: [
        {
          id: '',
          name: '我是群组'
        }
      ],
      dialogType: 0,
      editId: '',
      editGroupTypeId: '',
      page: 1,
      closeChoose: '收起筛选',
      groupName: '',
      groups: [],
      deleteArrayIds: [],
      checkAll: true,
      smsType: {
        0: '通知类',
        1: '营销类'
      },
      groupTypeIndex: 0,
      isDisabled: false,
      editMessageId: '',
      subSelectedEvent: '',
      butsObj: { // button按钮列表
        details: false,
        add: false,
        start_or_stop: false,
        edit: false,
        add_group: false,
        edit_group: false,
        del_group: false,
        del: false
      }
    }
  },
  computed: {
    ...mapGetters([
      'getConditions'
    ]),
    Newitems() {
      let _this = this
      if (_this.groupName === '') {
        return
      }
      _this.groups.map(function(item) {
        _this.$set(item, 'choosen', item.name.search(_this.groupName) != -1)
      })
      return _this.$set(item, 'choosen', item.name.search(_this.groupName) != -1)
    }
  },
  methods: {
    // 获取可用菜单按钮列表
    getButtonsList () {
      let params = {
        systemCode: 'ZY_INTELLIQUOR',
        authKey: Lockr.get('authKey'),
        sessionId: Lockr.get('sessionId'),
        menuId: getMenId(this.$route.path)
      }
      butonsList(params).then(res=>{
        if (res.data.code === '200') {
          let result = res.data.result || []
          let arrObj = Object.keys(this.butsObj)
          let newarr  = result.map((item)=>{
            return item.perms
          })
          arrObj.map(it=> {
            if (newarr.indexOf(it)!==-1) {
              this.butsObj[it] = true
            } else {
              this.butsObj[it] = false
            }
          })
        }
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    openAdd() {
      this.addAutomationGroupDialog = true
      this.addGroupForm.automationGroupName = ''
    },
    searchLoad() {
      this.page = 1
      this.searchName = JSON.parse(JSON.stringify(this.searchNameTmp))
      this.load()
    },
    // 启动流程
    doThis(id) {
      changeFlowChartStatus(id, 2).then((res) => {
        if (res.data.code === 0) {
          console.log('#', res)
          _g.toastMsg('success', '启用成功')
          this.load()
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 停止流程
    stopThis(id) {
      changeFlowChartStatus(id, 3).then((res) => {
        if (res.data.code === 0) {
          console.log(res)
          _g.toastMsg('success', '停止成功')
          this.load()
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 获取子组件的值
    getValue(value) {
      this.timeValue = value
      console.log('value', value)
    },
    ...mapMutations([
      'setConditions'
    ]),
    selectGroupAction(value) {
      console.log('sssssssss', this.procressForm)
    },
    // 地区
    update() {

    },
    // 实时营销事情发生部分属性
    activitySelectChange(value) {
      console.log('value', value)
      this.subSelectedEvent = ''
      this.changeOptions = []
      if (value[0] === 'wechat') {
        this.selectShow = true
        this.getWechatPublicList()
      } else if (value[0] === 'wepage') {
        this.selectShow = true
        this.getWePagesList()
      } else if (value[0] === 'sms') {
        this.selectShow = true
        this.getMessageTemplateList()
      } else if (value[0] === 'order') {
        this.selectShow = false
      } else if (value[0] === 'member' || value[0] === 'user_defined_event') {
        this.selectShow = false
      } else if (value[0] === 'Interactive_activities') {
        console.log('2202')
        this.selectShow = true
        this.loadBigWheelList()
      }
    },
    // 请求大转盘列表
    loadBigWheelList() {
      getBigWheelList({ status: 1 }).then((res) => {
        for (let item of res.data.data.list) {
          this.changeOptions.push({
            label: item.name,
            value: item.id
          })
        }
      })
    },
    // 请求微信公众号列表
    getWechatPublicList() {
      getWechatPublicListForNode().then((res) => {
        for (let item of res.data.data.list) {
          this.changeOptions.push({
            label: item.nick_name,
            value: item.id
          })
        }
      })
    },
    // 请求微页面列表
    getWePagesList() {
      getWePagesListForNode().then((res) => {
        for (let item of res.data.data.list) {
          this.changeOptions.push({
            label: item.admin_title,
            value: item.id
          })
        }
      })
    },
    // 营销活动 事件列表
    getActivityList() {
      getEventList().then((res) => {
        console.log('3020', res.data.data.list)
        for (let list of res.data.data.list) {
          for (let i in list.children) {
            list.children[i].label = list.children[i].name
            list.children[i].value = list.children[i].identity
          }
        }
        for (let ite of res.data.data.list) {
          if (ite.identity === 'wepage') {
            for (let i in ite.children) {
              if (ite.children[i].identity === 'wepage_forward_to_wechat') {
                ite.children.splice(i, 1)
              }
              if (ite.children[i].identity === 'wepage_forward_to_we_friend') {
                ite.children.splice(i, 1)
              }
            }
          }
        }
        for (let item of res.data.data.list) {
          if (item.identity === 'member') {
            continue
          }
          this.activityOptions.push({
            value: item.identity,
            label: item.name,
            children: item.children
          })
        }
      })
    },
    // 短信消息模板列表
    getMessageTemplateList() {
      getMessageList(1, this.search).then((res) => {
        console.log('getWePagesListForNode', res)
        for (let item of res.data.data.list) {
          this.changeOptions.push({
            label: item.sms_name,
            value: item.id
          })
        }
      })
    },
    // 删除流程
    deleteAutomationAction(item) {
      this.$confirm('确认删除该流程?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteAutomation(item.id).then((res) => {
          if (res.data.code === 0) {
            this.load()
            _g.toastMsg('success', '删除流程成功')
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    // 获取客户属性
    getCustomerAttributeList() {
      getCustomerAttributeList().then((res) => {
        if (res.data.code === 0) {
          let data = res.data.data
          let remainData = []
          // 循环删除省市区国家以及checkbox的元素  并且radio的改为select
          for (let i in data) {
            if (data[i].identity === 'district' || data[i].identity === 'city' || data[i].identity === 'province' || data[i].identity === 'country' || data[i].identity === 'stage_id' || data[i].identity === 'source_id') {
              continue
            }
            if (data[i].is_system === 0) {
              continue
            }
            remainData.push(data[i])
          }
          // 拼接处理获得的属性列表到本地数据
          for (let i in remainData) {
            remainData[i].value = remainData[i].identity // + '@' + remainData[i].type
            remainData[i].label = remainData[i].name
          }
          remainData.push({
            label: '省市区',
            value: 'addressPicker',
            identity: 'addressPicker',
            type: 'addressPicker'
          })
          this.attributeOptions = remainData
          console.log('this.attributeOptions[0].children', this.attributeOptions)
        }
      })
    },
    selectAttributeChange(value) {
      this.selectAttribute = null
      for (let item of this.attributeOptions) {
        if (value[0] === item.identity) {
          this.controlType = item.type
          if (value[0] === 'source_id') {
            let arr = []
            getSourceData().then((res) => {
              for (let items of res.data.data.list) {
                arr.push(items.name)
              }
              this.selectOptions = arr
              console.log('101', this.selectOptions)
            })
          } else if (value[0] === 'stage_id') {
            console.log('102')
            getCustomerStage().then((res) => {
              let arrs = []
              arrs = ['未知等级']
              for (let itemss of res.data.data) {
                arrs.push(itemss.name)
              }
              this.selectOptions = arrs
              console.log('102', this.selectOptions)
            })
          } else {
            this.selectOptions = item.option
          }
        }
      }
      // console.log('selectAttributeChange', this.attrSelectedOptions)
      // console.log('this.selectOptions', this.selectOptions)
    },
    handleChange(value) {
      console.log(value)
    },
    dateChange() {
      this.dayRadio = this.dateRadio
    },
    // 确认添加流程
    confirmAdd() {
      if (this.selectIndex === 0) {
        let startCondition = {
          actualContent: {}
        }
        startCondition.type = 0
        // 校验每一步是否
        if (this.procressForm.query_id === '') {
          _g.toastMsg('error', '群组不能为空')
          return
        } else {
          startCondition.query_id = this.procressForm.query_id
        }
        if (this.procressForm.procressName === '') {
          _g.toastMsg('error', '流程名不能为空，不能重复')
          return
        } else {
          startCondition.name = this.procressForm.procressName
        }
        if (this.selectRadio === 0) {
          startCondition.actualContent.triggerConditions = 'event'
          startCondition.actualContent.eventLimit = this.checked
          if (this.selectedOptions.length === 0) {
            _g.toastMsg('error', '事件不能为空')
            return
          } else {
            startCondition.actualContent.eventNames = this.selectedOptions
          }
          if (this.selectedOptions[0] === 'wechat' || this.selectedOptions[0] === 'wepage' || this.selectedOptions[0] === 'sms') {
            if (this.subSelectedEvent === '') {
              _g.toastMsg('error', '事件内容不能为空')
              return
            } else {
              startCondition.actualContent.eventContent = this.subSelectedEvent
            }
          } else {
            startCondition.actualContent.eventContent = this.subSelectedEvent
          }
        } else if (this.selectRadio === 1) {
          startCondition.actualContent.triggerConditions = 'activity'
          startCondition.actualContent.eventLimit = false
          if (this.selectUpAndDown === '') {
            _g.toastMsg('error', '活跃度关系不能为空')
            return
          } else {
            startCondition.actualContent.activityRelationship = this.selectUpAndDown
          }
          if (this.activityNum === '') {
            _g.toastMsg('error', '活跃度数值不能为空')
            return
          } else {
            startCondition.actualContent.activityNum = this.activityNum
          }
        } else if (this.selectRadio === 2) {
          startCondition.actualContent.triggerConditions = 'attr'
          startCondition.actualContent.eventLimit = this.attributeSelect
          if (this.attrSelectedOptions.length === 0) {
            _g.toastMsg('error', '属性名称不能为空')
            return
          } else {
            startCondition.actualContent.attrNames = this.attrSelectedOptions
          }
          if (this.relationSelect === '') {
            _g.toastMsg('error', '属性关系不能为空')
            return
          } else {
            startCondition.actualContent.attrRelationship = this.relationSelect
          }
          if (this.selectAttribute === '') {
            _g.toastMsg('error', '属性内容不能为空')
            return
          } else {
            startCondition.actualContent.attrContent = this.selectAttribute
          }
          startCondition.actualContent.attrShowType = this.controlType
        }
        console.log('startCondition', startCondition)
        this.setConditions(startCondition)
        router.push('/home/flow-chart')
      } else if (this.selectIndex === 1) {
        let startCondition = {
          actualContent: {}
        }
        startCondition.type = 1
        if (this.oneForm.query_id === '') {
          _g.toastMsg('error', '群组不能为空')
          return
        } else {
          startCondition.query_id = this.oneForm.query_id
        }
        if (this.oneForm.procressName === '') {
          _g.toastMsg('error', '流程名不能为空，不能重复')
          return
        } else {
          startCondition.name = this.oneForm.procressName
        }
        this.setConditions(startCondition)
        router.push('/home/flow-chart')
      } else if (this.selectIndex === 2) {
        let startCondition = {
          actualContent: {}
        }
        startCondition.type = 2
        if (this.loopForm.query_id === '') {
          _g.toastMsg('error', '群组不能为空')
          return
        } else {
          startCondition.query_id = this.loopForm.query_id
        }
        if (this.loopForm.procressName === '') {
          _g.toastMsg('error', '流程名不能为空，不能重复')
          return
        } else {
          startCondition.name = this.loopForm.procressName
        }
        startCondition.actualContent.dateMethod = this.dateRadio
        startCondition.actualContent.weekNum = this.timeValue.weekNum
        startCondition.actualContent.dayNum = this.timeValue.dayNum
        startCondition.actualContent.monthNum = this.timeValue.monthNum
        startCondition.actualContent.yearDayNum = this.timeValue.yearDayNum
        startCondition.actualContent.dayOne = this.timeValue.dayOne
        let timeSetStart = parseInt(new Date(new Date().setTime(this.startEnd[0])) / 1000)
        let timeSetEnd = parseInt(new Date(new Date().setTime(this.startEnd[1])) / 1000)
        let timeSet = parseInt(new Date(new Date().setTime(this.realTime)) / 1000)
        if (timeSet === 0) {
          _g.toastMsg('error', '具体时间不能为空')
          return
        } else {
          startCondition.actualContent.realTime = timeSet
        }
        let newStartEnd = []
        newStartEnd.push(timeSetStart)
        newStartEnd.push(timeSetEnd)
        if (isNaN(newStartEnd[0])) {
          _g.toastMsg('error', '起止时间不能为空')
          return
        } else {
          startCondition.actualContent.startEnd = newStartEnd
        }
        this.setConditions(startCondition)
        router.push('/home/flow-chart')
      }
    },
    selectRadioChange() {
      if (this.selectRadio === 0) {
        // 属性清空
        this.attributeSelect = false
        this.attrSelectedOptions = []
        this.relationSelect = ''
        this.selectAttribute = ''
        // 客户活跃度清空
        this.selectActivityChange = ''
        this.selectUpAndDown = ''
        this.activityNum = ''
      } else if (this.selectRadio === 1) {
        // 事情发生清空
        this.selectedOptions = []
        this.subSelectedEvent = ''
        this.checked = false
        // 属性清空
        this.attributeSelect = false
        this.attrSelectedOptions = []
        this.relationSelect = ''
        this.selectAttribute = ''
      } else if (this.selectRadio === 2) {
        // 事情发生清空
        this.selectedOptions = []
        this.subSelectedEvent = ''
        this.checked = false
        // 客户活跃度清空
        this.selectActivityChange = ''
        this.selectUpAndDown = ''
        this.activityNum = ''
      }
    },
    procressSelectAction(index) {
      this.selectIndex = index
      this.procressForm.type = index
      for (var i = this.procressLeftData.length - 1; i >= 0; i--) {
        if (i == index) {
          this.procressLeftData[i].selected = true
        } else {
          this.procressLeftData[i].selected = false
        }
      }
    },
    createActoProcress() {
      this.createdAutoProcressDialog = true
    },
    // 打开统计弹窗
    openTotalDialog(id) {
      this.totalDialog = true
      megSendStatistic(id).then(res => {
        this.totalData = res.data.data.list
      })
    },
    // 查看
    look(item) {
      router.push({path: '/home/flow-chart', query: {id: item.id}})
    },
    // 打开编辑弹窗
    openEditMessageDialog(item) {
      router.push({path: '/home/flow-chart', query: {id: item.id}})
    },
    // 查找群组类型
    searchGroupType() {
      console.log('this.groups', this.groups)
      for (let i in this.groups) {
        this.groups[i].choosen = false
        for (let j in this.Newitems) {
          if (this.groups[i].id === this.Newitems[j].id) {
            this.groups[i].choosen = true
          }
        }
      }
    },
    // 点选群组类型
    chooseGroupType(index, item) {
      this.groupTypeIndex = index
      this.selectGroupId = item.id
      this.page = 1
      this.load()
    },
    // 确认移到分组
    confirmChooseGroupType() {
      moveAutomationGroupId(this.group_id, this.deleteArrayIds).then((res) => {
        if (res.data.code === 0) {
          this.load()
          this.group_id = ''
          _g.toastMsg('success', '分组成功')
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 全选
    handleSelectionChange(val) {
      this.deleteArrayIds = []
      for (let i in val) {
        this.deleteArrayIds.push(val[i].id)
      }
      if (parseInt(val.length) > 0) {
        this.checkAll = false
      } else {
        this.checkAll = true
      }
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
      this.load()
    },
    handleCurrentChange(page) {
      this.page = page
      this.load()
    },
    // 流程列表
    load() {
      this.loading = true
      getAutomationList(this.page, this.selectGroupId, this.searchName).then((res) => {
        this.tableData = res.data.data.list
        this.totalCount = res.data.data.count
        this.openLoading()
      })
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 添加分组
    addGroup() {
      this.adddialog = true
    },
    // 自动流程分组列表
    loadGroupType() {
      getFlowChartGroup().then((res) => {
        if (res.data.code === 0) {
          // res.data.data.list.unshift({ id: '', name: '全部' })
          for (let item of res.data.data.list) {
            item.choosen = false
          }
          this.groups = res.data.data.list
          this.queryGroups = res.data.data.list
        }
      })
    },
    // 左侧分组导航
    handleOpen(key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    },
    // 添加左侧自动流程分组
    addGroupTypeItem() {
      if (this.addGroupForm.automationGroupName === '') {
        _g.toastMsg('error', '请输入分组名称')
        return
      }
      addAutomationGroup(this.addGroupForm.automationGroupName).then((res) => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
          this.addAutomationGroupDialog = false
        } else {
          _g.toastMsg('error', res.data.error)
        }
        this.loadGroupType()
      })
    },
    // 编辑分组名称
    editGroupTypeItem() {
      if (this.addGroupForm.automationGroupName === '') {
        _g.toastMsg('error', '请输入分组名称')
        return
      }
      editAutomationGroupById(this.addGroupForm.automationGroupName, this.selectGroupId).then((res) => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
          this.editAutomationGroupDialog = false
        } else {
          _g.toastMsg('error', res.data.error)
        }
        this.loadGroupType()
      })
    },
    deleteGroupTypeItem(item) {
      this.$confirm('确认删除该流程分组?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteAutomationGroupById(item.id).then((res) => {
          if (res.data.code === 0) {
            this.loadGroupType()
            _g.toastMsg('success', '删除流程分组成功')
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    // 获取群组列表
    loadCustomerGroup() {
      getGroupList().then((res) => {
        if (res.data.code === 0) {
          this.selectGroupOptions = res.data.data.list
        }
      })
    }
  },
  components: {
    TemplateMessage,
    DateTemplate
  },
  created() {
    this.getButtonsList()
    this.load()
    this.loadGroupType()
    this.getActivityList()
    this.getCustomerAttributeList()
    this.loadCustomerGroup()
  }
}
</script>

<style scoped>
  .auto-process-line{
    width: 340px;
    height: 1px;
    background: #E7E7E7;
    margin-left: 117px;
  }
  .menu-title{width: 100px;display: block;overflow: hidden; white-space: nowrap; text-overflow: ellipsis;}
  .el-menu-item .menu-btn{display:none;float:right;}
  .el-menu-item:hover .menu-btn{display: block}
.top-nav{
  width: 100%;
  height: 50px;
  line-height: 50px;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
}
.top-nav div{
  width: 50%;
  border-bottom: 1px solid #fff;
  cursor: pointer;
}
.top-nav .active{
  border-bottom: 1px solid red;
  color: red;
}
.disabled{
  background: #ccc!important;
}
.getIt{
  color: #FF5500!important;
}
.cancelCreate{
  float: right;
  margin-right: 10px;
  color: #ff7373;
  cursor: pointer;
}
.el-menu-vertical-demo{
  position: relative;
}
.group-search{
  height: 60px;
  background: #fff;
  border-bottom: 1px solid #e5e5e5;
}
.text-align-left{
  text-align: left;
}
.text-align-right{
  text-align: right;
}

.table-title{
  text-align: left;
}
/*.search-title{
  background:#ecf6ff;
  border:1px solid #ebebeb;
  height:60px;
  padding:10px;
  line-height: 40px;
}*/
::-webkit-scrollbar
{
  width: 6px;  /*滚动条宽度*/
  height: 16px;  /*滚动条高度*/
}
/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track
{
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  border-radius: 10px;  /*滚动条的背景区域的圆角*/
  background-color: #f5f5f5;/*滚动条的背景颜色*/
}
/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb
{
  border-radius: 10px;  /*滚动条的圆角*/
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
  background-color: #ccc;  /*滚动条的背景颜色*/
}
.el-form-item__label {
  width: 190px;
}
.procress-left {
  height: 400px;
  width: 300px;
}
.auto-procress {
  width: 100%;
  height: 400px;
  float: left;
}
.auto-procress-condition ul {
  display: inline-block;
  width: 100%;
  margin-left: 0px;
  padding-left: 0px;
}
.auto-procress-condition ul li {
  float: left;
  width: 100%;
  height: 90px;
  line-height: 40px;
  cursor: pointer;
  display: inline-block;
  margin-top: 10px;
  /*border: 2px dashed #1890FF;*/
  color: #fff;
  background-size: 100% 100%;
}
.auto-procress-condition ul li:nth-child(1){
  background: url("../../assets/images/0-0.png") no-repeat center center;
}
.auto-procress-condition ul li:nth-child(2){
  background: url("../../assets/images/0-4.png") no-repeat center center;
}
.auto-procress-condition ul li:nth-child(3){
  background: url("../../assets/images/0-5.png") no-repeat center center;
}
.auto-procress-condition ul li.active:first-child{
  background: url("../../assets/images/0-1.png") no-repeat center center;
  background-size: 100% 100%;
}
.auto-procress-condition ul li.active:nth-child(2){
  background: url("../../assets/images/0-2.png") no-repeat center center;
  background-size: 100% 100%;
}
.auto-procress-condition ul li.active:last-child{
  background: url("../../assets/images/0-3.png") no-repeat center center;
  background-size: 100% 100%;
}
.procress-left-select {
 width: 100%;
 padding-top: 20px;
 height: 70px;
 float: left;
}
.procress-left-select {
  text-align: center;
}
.procress-left-select :first-child {
  padding: 0px;
  margin: 5px 0 0 0;
  line-height: 40px;
  /*color: #ccc;*/
  font-size: 16px;
  font-weight: bold
}
.procress-left-select :nth-child(2) {
  padding: 0px;
  margin: 0px;
  line-height: 14px;
  /*color: #ccc;*/
  font-size: 12px;
  padding-left: 20px;
  padding-right: 20px;
  text-align: left;
}
.procress-right {
  margin-left: 0px;
  margin-top: 20px;
  width: 500px;
  height: 400px;
}
.time-tips {
  font-size: 12px;
  color: #666;
  margin-top: 5px;
  height: 25px;
  line-height: 25px;
  width: 260px;
  background: #fffaeb;
  border: 1px solid #fff3cf;
}
.auto-procress .newMessageForm .el-input--suffix .el-input__inner{
  width: 280px;
}
.auto-procress .totalPage .el-input__inner{
  width: 40px;
}
.auto-procress .cellDialog .totalPage .el-input{
  width: 40px;
  margin: 0 10px;
}
.auto-procress .cellDialog .el-input{
  width: 280px;
}
.auto-procress .cellDialog .el-textarea.is-disabled .el-textarea__inner{
  width: 280px;
}

</style>
